import { IBSelectState, ISelectOption } from './Select.types';

export const onSelectKeyDown = (
  e: any,
  disabled: boolean,
  state: IBSelectState,
  setState: (state: IBSelectState) => void
) => {
  if (e.keyCode === 9) {
    if (!disabled && !state.show) {
      e.stopPropagation();
      e.preventDefault();
      setState({ show: true });
    }
  }
};

export const onSelectClick = (
  disabled: boolean,
  state: IBSelectState,
  setState: (state: IBSelectState) => void
) => {
  if (!disabled) {
    setState({ show: !state.show });
  }
};

export const onSelectOptionClick = (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  option: ISelectOption,
  onChange: (option: ISelectOption) => void,
  setState: (state: IBSelectState) => void
) => {
  e.stopPropagation();
  e.preventDefault();
  if (onChange) {
    onChange(option);
  }
  setState({ show: false });
};

export const prepareOptions = (
  options: ISelectOption[],
  useGroups: boolean
): ISelectOption[] => {
  if (!useGroups) {
    return options;
  }
  const groupsWithDuplicates = options.map(o => o.group.toUpperCase() ?? '');
  const groups = groupsWithDuplicates.filter(
    (n, i) => groupsWithDuplicates.indexOf(n) === i
  );
  let sortedOptions: ISelectOption[] = [];
  groups.forEach(g => {
    const groupOptions: ISelectOption[] = options
      .filter(o => o.group.toUpperCase() === g.toUpperCase())
      .map((o, i) => {
        if (i === 0) {
          return o;
        }
        return { ...o, groupLabelVisible: '' };
      });

    sortedOptions = [...sortedOptions, ...groupOptions];
  });
  return sortedOptions;
};
